module.exports = __webpack_public_path__ + "media/images/admin/icons/power-81d324791099948106e7f86e2a7cda01.svg";